// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__wXgSz","active":"Tabs_active__nFODj"};